import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'ns-joint-personal-info',
  template: require('./joint-personal-info.component.html')
})

export class JointPersonalInfoComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);
    const steps = this.flowManager.getStepArrays('joint-info');
    this.form.stepsComplete = steps.stepsComplete;
    this.form.stepsToComplete = steps.stepsToComplete;

    const lastStep = this.form.stepsComplete[this.form.stepsComplete.length - 1];
    this.form.buttons.inputs.back.path = `/${lastStep.route}`;
  }

  updateOptionValue(event) {
    // console.log('Form Route', event);
  }
}
